// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Navigation_wrapper__2fbpu","navLink":"Navigation_navLink__2THVz","navLinkActive":"Navigation_navLinkActive__302EM"};